import clickEvent from './clickEvent';
import initOffset from '../../common/initOffset';

export default function initOffsetEvent() {
  initOffset(clickEvent, '.js-header__links-click-events');
}
